// extracted by mini-css-extract-plugin
export default {"component":"hld-L"};